module.exports = __webpack_public_path__ + "fonts/notosans-light-web.1804041.woff2";